module.exports = __webpack_public_path__ + "img/20.a0e8c9fd.svg";